import React from "react";
import {InvestorData} from "../resources/navbar-data/sidebarData"
import Sidebar from "../common/Sidebar"

const Investor = ({children}) => {
  // eslint-disable-next-line react/no-children-prop
  return <Sidebar SidebarData={InvestorData} children={children}/>
}

export default Investor